import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.style.scss';
import { encrypt } from "../../utilities/Encriptacion";

const NotFound = () => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    return (
        <div className="not-found">
            <div className="not-found-content">
                <h1>404</h1>
                <h2>Página No Encontrada</h2>
                <p>Lo sentimos, la página que buscas no existe o ha sido movida.</p>
                <Link to="/" onClick={() => {
                    sessionStorage.clear()
                    sessionStorage.setItem("auth", encrypt("false", CLAVE));
                }} className="home-link">Volver a Inicio</Link>
            </div>
        </div>
    );
};

export default NotFound;
